import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/intelligent/page',
    method: 'post',
    data
  })
}

export const getSummary = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/intelligent/summary',
    method: 'post',
    data
  })
}

export const exportExcel = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/warehousing/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export const getOwnerList = () => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get'
  })
}
